
import { Component, Vue, Emit, Prop, Watch } from "vue-property-decorator";
import appconst from "@/lib/appconst";
import * as imageConversion from "image-conversion";

@Component
export default class ImageUploader extends Vue {
  
  private faceUploadAction =appconst.remoteServiceBaseUrl + 'sysadmin/UploadFile/ProductUpload'// `${appconst.remoteServiceBaseUrl}/admin/api/Image/Upload`;
  private previewImageUrl = null;
  private faceUploading = false;

  @Prop({ default: null })
  readonly url: string;

  @Prop({ default: "上传图片" })
  readonly uploadText: string;

  @Prop({ default: "重新上传" })
  readonly reuploadText: string;

  @Prop({ default: null })
  readonly accept: string;

  @Prop({ default: "" })
  readonly tips: string;

  @Prop({ default: null })
  readonly customClass: string

  @Prop({ default: false })
  readonly asidePreview: boolean

  @Watch("url")
  private onUrlChange(val) {
    this.previewImageUrl = val;
  }

  private mounted() {
    this.previewImageUrl = this.url;
  }

  private onFaceUpladSuccess(response, file, fileList) {
    this.faceUploading = false;
    this.previewImageUrl = response.result.url;
    this.onSuccess(response.result.url);
  }

  private onFaceUploadError(error) {
    this.faceUploading = false;
    this.previewImageUrl = this.url;
    try {
      let data = JSON.parse(error.message);
      if (data.error.message) {
        if (data.error.details) {
          this.$message({
            type: "error",
            message: this.$createElement("p", [
              this.$createElement(
                "p",
                {
                  style: {
                    fontSize: "14px",
                    color: "#999",
                    marginBottom: "6px",
                  },
                },
                data.error.message
              ),
              this.$createElement("p", data.error.details),
            ]),
          });
        } else {
          this.$message.error(data.error.message);
        }
      } else {
        this.$message.error("图片上传失败");
      }
    } catch {
      this.$message.error("图片上传失败");
    }
  }

  private onFaceBeforeUpload(file: File) {
    return new Promise((resolve, reject) => {
      // if (!(file.type === "image/jpeg" || file.type === "image/png")) {
      //   this.$message.error("上传的图片只能是jpg或png格式");
      //   reject();
      // } else {
      if (!file.type.startsWith('image/') ||
          this.accept && !this.accept.split(',').some(x => file.name.endsWith(x.trim()))) {
        this.$message.error(`上传的图片只能是${ this.accept ? this.accept.replace(',', '、').replace('.', '') : '图片文件' }格式`);
        reject();
      } else {
        this.previewImageUrl = URL.createObjectURL(file);
        imageConversion.compressAccurately(file, { size: 800 }).then((res) => {
          this.faceUploading = true;
          resolve(res);
        });
      }
    });
  }

  @Emit("success")
  private onSuccess(url: string) {}
}
